import { Card } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import React from 'react';
import PricingTable from './PricingTable';
import PaymentCalculation from './PaymentCalculation';

const CardFooter = ({
  isTeammate,
  translate,
  total_price,
  discount,
  price_shipping,
  order_shipping,
  hasLargeOrder,
  pay_type,
  showWalletInfo,
  credit,
  deposit_price,
  total_discount,
  total_gr,
  gold_gram_cart_usage = 0,
  gold = 0,
}) => {
  if (isTeammate) {
    return (
      <Card.Footer className='text-muted login-footer' style={footerStyles.container}>
        <div style={footerStyles.summaryContainer}>
          {/* مجموع تخفیف */}
          <div style={footerStyles.summaryRow}>
            <span style={footerStyles.label}>مجموع تخفیف</span>
            <span style={footerStyles.value}>
              <NumberFormat suffix={` ${translate('weight-unit')}`} value={total_discount} displayType='text' thousandSeparator={true} />
            </span>
          </div>

          {/* جمع کل سبد خرید */}
          <div style={footerStyles.summaryRow}>
            <span style={footerStyles.label}>جمع کل سبد خرید</span>
            <span style={footerStyles.value}>
              <NumberFormat suffix={` ${translate('weight-unit')}`} value={total_gr} displayType='text' thousandSeparator={true} />
            </span>
          </div>

          {/* هزینه ارسال */}
          <div style={footerStyles.summaryRow}>
            <span style={footerStyles.label}>هزینه ارسال</span>
            <span style={footerStyles.value}>
              <NumberFormat suffix={` ${translate('price-unit')}`} value={price_shipping} displayType='text' thousandSeparator={true} />
            </span>
          </div>
        </div>
      </Card.Footer>
    );
  }

  return (
    <Card.Footer className='text-muted login-footer' style={footerStyles.container}>
      {/* جدول قیمت‌گذاری */}
      <div style={footerStyles.pricingSection}>
        <div style={footerStyles.summaryContainer}>
          {/* مبلغ کل */}
          <div style={footerStyles.summaryRow}>
            <span style={footerStyles.label}>مبلغ کل</span>
            <span style={footerStyles.value}>
              <NumberFormat suffix={` ${translate('price-unit')}`} value={total_price} displayType='text' thousandSeparator={true} />
            </span>
          </div>

          {/* مجموع تخفیف */}
          {discount?.success && (
            <div style={footerStyles.summaryRow}>
              <span style={footerStyles.label}>مجموع تخفیف</span>
              <span style={{ ...footerStyles.value, color: '#dc3545' }}>
                <NumberFormat suffix={` ${translate('price-unit')}`} value={(discount.amount || 0) / 10} displayType='text' thousandSeparator={true} />
              </span>
            </div>
          )}

          {/* هزینه ارسال */}
          <div style={footerStyles.summaryRow}>
            <span style={footerStyles.label}>هزینه ارسال</span>
            <span style={footerStyles.value}>
              {price_shipping === 0 || price_shipping === '0' ? (
                <span style={{ color: '#28a745', fontWeight: '600' }}>{order_shipping === 1 ? 'پرداخت در محل' : 'رایگان'}</span>
              ) : (
                <NumberFormat value={price_shipping} displayType='text' suffix=' تومان' thousandSeparator={true} />
              )}
            </span>
          </div>
        </div>
      </div>

      <hr style={footerStyles.divider} />

      <PaymentCalculation
        hasLargeOrder={hasLargeOrder}
        total_price={total_price}
        price_shipping={price_shipping}
        pay_type={pay_type}
        showWalletInfo={showWalletInfo}
        credit={credit}
        deposit_price={deposit_price}
        discount={discount}
        gold_gram_cart_usage={gold_gram_cart_usage}
        gold={gold}
      />
    </Card.Footer>
  );
};

const footerStyles = {
  container: {
    backgroundColor: '#f8f9fa',
    border: 'none',
    borderTop: '1px solid #dee2e6',
    padding: '20px',
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
  },

  summaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
  },

  summaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 0',
    borderBottom: '1px solid rgba(0,0,0,0.05)',
  },

  label: {
    fontSize: '14px',
    color: '#495057',
    fontWeight: '500',
    flex: '1',
    textAlign: 'right',
  },

  value: {
    fontSize: '14px',
    color: '#212529',
    fontWeight: '500',
    textAlign: 'left',
    minWidth: '120px',
    direction: 'rtl',
  },

  pricingSection: {
    marginBottom: '16px',
  },

  divider: {
    backgroundColor: '#dee2e6',
    margin: '16px 0',
    border: 'none',
    height: '1px',
  },
};

// اضافه کردن CSS برای responsive
const cardFooterCSS = `
.login-footer {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  backdrop-filter: blur(10px);
  border: none;
  border-top: 1px solid #dee2e6;
}

/* Responsive Design */
@media (max-width: 576px) {
  .login-footer {
    padding: 16px !important;
  }
  
  .login-footer .summary-row {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 4px;
    padding: 12px 0 !important;
  }
  
  .login-footer .summary-row .label {
    font-size: 13px !important;
    text-align: right !important;
    width: 100% !important;
  }
  
  .login-footer .summary-row .value {
    font-size: 14px !important;
    text-align: right !important;
    width: 100% !important;
    min-width: auto !important;
     direction: rtl !important;
  }
}

@media (max-width: 768px) {
  .login-footer .summary-container {
    gap: 8px !important;
  }
  
  .login-footer .summary-row {
    padding: 10px 0 !important;
  }
}

/* RTL Support */
[dir="rtl"] .login-footer .summary-row .value {
  text-align: right;
  direction: rtl;
}

[dir="rtl"] .login-footer .summary-row .label {
  text-align: right;
}

/* Hover effects */
.login-footer .summary-row:hover {
  background-color: rgba(0,0,0,0.02);
  border-radius: 6px;
  margin: 0 -8px;
  padding: 8px 8px !important;
  transition: all 0.2s ease;
}

/* Animation for loading */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.login-footer .summary-row {
  animation: fadeIn 0.3s ease forwards;
}

.login-footer .summary-row:nth-child(2) {
  animation-delay: 0.1s;
}

.login-footer .summary-row:nth-child(3) {
  animation-delay: 0.2s;
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .login-footer {
    background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%);
    border-top-color: #4a5568;
  }
  
  .login-footer .summary-row {
    border-bottom-color: rgba(255,255,255,0.1);
  }
  
  .login-footer .summary-row .label {
    color: #a0aec0;
  }
  
  .login-footer .summary-row .value {
    color: #f7fafc;
  }
  
  .login-footer .summary-row:hover {
    background-color: rgba(255,255,255,0.05);
  }
  
  .login-footer hr {
    background-color: #4a5568;
  }
}
`;

// Inject CSS
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = cardFooterCSS;
  if (!document.head.querySelector('style[data-card-footer]')) {
    styleElement.setAttribute('data-card-footer', 'true');
    document.head.appendChild(styleElement);
  }
}

export default CardFooter;
